import { Injectable, OnDestroy } from '@angular/core';
import { Product } from '../interfaces/product';
import { Observable, Subject, timer } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class QuickviewService implements OnDestroy {
    controllerName = "shop/";
    private destroy$: Subject<void> = new Subject();
    private showSubject$: Subject<Product> = new Subject();

    show$: Observable<Product> = this.showSubject$.pipe(takeUntil(this.destroy$));

    constructor(private http: HttpClient) { }

    show(productslug: String): Observable<void> {

        return this.http.get<any>(environment.apiurl + this.controllerName + "getoneproductbyslug/" + productslug).pipe(map(n=>this.showSubject$.next(n)));
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
